import getNewProducts, { ResGetNewProducts } from '@/service/market/new/getNewProducts';
import { useQuery } from '@tanstack/react-query';
import { RQNewKey } from './RQNewKey';

const useNewProductsQuery = () => {
  return useQuery<
    ResGetNewProducts,
    object,
    ResGetNewProducts['result']['content'],
    (typeof RQNewKey)['newHomeProducts']
  >({
    queryKey: RQNewKey['newHomeProducts'],
    queryFn: () => getNewProducts({ query: {} }),
    select: (data) => {
      return data.result.content.slice(0, 8);
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useNewProductsQuery;
